import gql from "graphql-tag";
import { Employee } from "../baseTypes";
export default gql`
  query ListEmployeesForLoction(
    $locationId: ID!
    $nextToken: String
    $limit: Int
  ) {
    listEmployees(
      locationId: $locationId
      limit: $limit
      nextToken: $nextToken
      sortDirection: ASC
    ) {
      items {
        locationId
        insuranceNumber
        identifier
        patient {
          firstname
          lastname
        }
      }
      nextToken
      __typename
    }
  }
`;
export interface ListEmployeesForLocationQuery {
  listEmployees: {
    items: Array<Employee> | null;
    nextToken?: string | null;
  };
}
